import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Horizon = () => {
  useEffect(() => {
    document.title = "Horizon | Under Open Sky";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <nav className="p-8 sticky top-0 bg-white/80 backdrop-blur-md z-10">
        <Link to="/" className="text-[10px] uppercase tracking-[0.2em] text-gray-400 hover:text-gray-800 transition-colors">
          ← Zurück zur Übersicht
        </Link>
      </nav>

      <article className="max-w-2xl mx-auto px-6 py-12 pb-40 font-light text-gray-600 leading-relaxed">
        <header className="mb-20">
          <h1 className="text-3xl font-light text-gray-800 mb-4 tracking-tight italic">Horizon</h1>
          <p className="text-gray-400 italic">Zeit auf dem Wasser</p>
        </header>
        
        <div className="space-y-10">
          <p>Horizon ist eine Einladung zu gemeinsamer Zeit auf dem Wasser. Auf dem Boot „Horizon 5“ findet sich Raum für bis zu zehn Personen, ergänzt durch mehrere Kabinen für Rückzug und Ruhe.</p>
          
          <p>Die Fahrten führen über die Mecklenburgische Seenplatte oder an andere geeignete Orte in Europa. Dabei gibt es kein festes Ziel, keinen Leistungsanspruch und keinen Erlebnisdruck.</p>
          
          <p>Der Fokus liegt schlicht auf dem Dasein. Auf der Weite, die das Wasser bietet, dem Himmel über uns und der direkten Gegenwärtigkeit des Moments.</p>
          
          <p>Es ist die besondere Qualität von Zeit, die nur unter freiem Himmel und in der steten Bewegung des Wassers entstehen kann. Ein Angebot für Menschen, die bewusst Zeit erleben möchten – jenseits technischer Details oder touristischer Programme.</p>
          
          <p className="pt-12 text-gray-800 italic font-normal">
            Es geht um die Erfahrung, wie sich Horizont und Bewegung langsam miteinander verbinden, bis sie nicht mehr zu trennen sind.
          </p>
        </div>
      </article>
    </div>
  );
};

export default Horizon;